export const dgiContMapping = (productName) => {
  const map = new Map();

  map.set('DGI Balanced Fund IRA - Contribution', 'DGI Contribution');
  map.set('DGI Balanced Fund IRA - Aportaciones', 'DGI Contribution');
  map.set('DGI Contribution', 'DGI Contribution');
  map.set('DGI Aportaciones', 'DGI Contribution');

  return map.get(productName);
};
